import { omitBy } from 'lodash-es';
import type { Types } from '../../types';
import type { ConnectedTypes } from '../../make-connected';
import { parseDayIndices } from './util/parse-days';
import { parseMaxWorkingHours } from './util/parse-max-working-hours';
import { idOf } from './util/util';
import { getDefaultInterval } from './intervals';

export function fromGroups (
  groups:   ConnectedTypes.group[],
  settings: ConnectedTypes.divisionSettings,
  options:  Types.parsedToOptions
): Types.Entities.Group[] {
  const defaultInterval = getDefaultInterval(settings);

  return groups
    .filter(group => group.species == 'class')
    .map(group => {
      const intervals    = group.intervals    ?? defaultInterval;
      const rootInterval = group.rootInterval ?? settings.defaultRootInterval;

      const doc: Types.Entities.Group = {
        id:                            idOf.group(group, options),
        group_type:                    'classes',
        weight:                        group.weight,
        minimizeGaps:                  true,
        minimizeDependencyAlternation: false,
        intervals:                     idOf.intervalPairReference(intervals, rootInterval, options),
        days:                          parseDayIndices(group.days, settings),
        blockedTimes:                  group.lockedTimes?.map(x => idOf.lockedTime(x, options)),
        minBreakDuration:              group.minBreakLength,
        ...parseMaxWorkingHours(group),
      };

      if (options.includeEntityMeta) {
        doc.name = group.displayName;
      }

      return omitBy(doc, x => x == null) as Types.Entities.Group;
    });
};
